import React from "react";

export const OnlineStatusContext = React.createContext();
